module.exports = __webpack_public_path__ + "img/pancakeswap-cake-logo.af6957bb.svg";